export default {
  icon: 'business',
  name: 'Installations',
  property: 'Installation',
  titles: {
    installation: 'Installations',
    setup: 'Set up',
  },
  FRI: 'FRI',
  noItems:
    "Il n'y a pas d'installations en relation avec l'organisation et les filtres sélectionnés",
  fields: {
    p1_monitoring: 'Installation calculable P1',
    m2m_remotemanagement_enabled: 'MyVision',
    market_type: 'Type de marché',
    top_p1: 'Top P1',
    purpose: 'Usage',
    property: 'Installation',
    type: 'Type',
    active: 'Installation active',
    business_name: 'Nom commercial',
    name: 'Nom',
    shortname: 'Nom court',
    code: 'Code',
    street: 'Rue',
    address: 'Adresse',
    city: 'Ville',
    postal_code: 'Code postal',
    entity_id: 'Organisation',
    logbook_entries: "Nombre d'entrées",
    entity_name: 'Equipe',
    act_list: 'Actions',
    acp_list: "Plans d'actions",
  },
  documents: {
    noCategory: 'Veuillez renseigner une catégorie',
    interventionId: 'Intervention n° {interventionId}',
  },
  ignitions: {
    fields: {
      name: 'Nom',
      shortname: 'Nom court',
      code: 'Code',
      street: 'Rue',
      address: 'Adresse',
      city: 'Ville',
      postal_code: 'Code postal',
      remoteEnabled: "Eligible à l'allumage/arrêt",
      setupParam: {
        activation_type: 'Mode',
        transmitter_type: 'Transmetteur',
      },
    },
  },
};
